import { ranking } from '@/mocks/home';

export default function RankingList() {
  const maxHeat = Math.max(...ranking.map((item) => item.heat));

  return (
    <div id="ranking" className="lg:col-span-2 scroll-mt-16">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="text-xs tracking-[0.25em] text-primary-600 font-label">RANKING · 热度榜</p>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            现在最值得先看的站点
          </h2>
        </div>
        <p className="hidden sm:block text-xs text-foreground-500 whitespace-nowrap">按综合播放热度排序</p>
      </div>

      <ol className="mt-6 border-t border-foreground-950/10">
        {ranking.map((item, idx) => (
          <li
            key={item.id}
            className="group flex items-center gap-3 md:gap-5 py-3.5 md:py-4 border-b border-foreground-950/10 hover:bg-background-100/60 transition-colors px-1"
          >
            <span
              className={`w-7 shrink-0 font-heading font-bold text-xl md:text-2xl ${
                idx < 3 ? 'text-primary-600' : 'text-foreground-300'
              }`}
            >
              {idx + 1}
            </span>

            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                  {item.title}
                </h3>
                <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <p className="mt-1 text-xs text-foreground-500 truncate">{item.desc}</p>
            </div>

            <div className="hidden sm:flex flex-col items-end shrink-0">
              <span className="font-label text-sm text-foreground-800">{item.heat.toLocaleString()}</span>
              <span className="mt-1.5 block w-20 h-1 rounded-full bg-foreground-950/10 overflow-hidden">
                <span
                  className="block h-full rounded-full bg-primary-500"
                  style={{ width: `${(item.heat / maxHeat) * 100}%` }}
                />
              </span>
            </div>

            <span className="w-4 h-4 hidden md:flex items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors">
              <i className="ri-arrow-right-line" />
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}